import React, { useState, useContext } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Collapse,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import { EditOutlined } from "@material-ui/icons";
import { GET_ROLES } from "lib/roles";
import { GetRolesQueryResult, Role } from "generated/graphql";

export default function RolesTable() {
  const history = useHistory();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetRolesQueryResult = useQuery(GET_ROLES, {
    variables: {
      limit,
      offset: page,
      buildingId: currentBuilding?.Id,
    },
  });

  const handleEditClick = (id: string) => {};

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Role) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Indoors</TableCell>
                    <TableCell>Charging Station</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Role.slice(0, limit).map((role) => (
                    <TableRow hover key={role.Id}>
                      <TableCell component="th" scope="row">
                        {role.Title}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {role.Indoors ? "yes" : "no"}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {role.IsChargingStation ? "yes" : "no"}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {role.Type}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {role.created_at}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {role.updated_at}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleEditClick(role.Id);
                          }}
                        >
                          <EditOutlined />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.Role_aggregate.aggregate?.count
                ? data.Role_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Roles</div>;
  }
}
